import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsColorMaterial = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M20.956 22.739 8.259 10.043 3 22.739zM22.739 3 10.042 8.259l12.697 12.697zm-1.783 22.261H3l5.259 12.697zm6.088 0 12.697 12.697L45 25.261zm-4.305 1.783L10.042 39.741 22.739 45zm2.522 0V45l12.697-5.259zM43.919 4.081a3.69 3.69 0 0 0-5.217 0L35.14 7.643l-1.426-1.426-2.179 2.179 1.426 1.426-7.881 7.881a3.689 3.689 0 0 0 5.216 5.216l7.881-7.881 1.426 1.426 2.179-2.179-1.426-1.426 3.562-3.563a3.685 3.685 0 0 0 .001-5.215M28.4 21.023a1 1 0 0 1-1.422 0 1.01 1.01 0 0 1 0-1.423l7.074-7.074 1.423 1.423z" }) }) })
});
export default SvgMetricsColorMaterial;
